<template>
  <path
    d="M2 10.7548L2 1.24523C2 0.183414 3.24036 -0.389415 4.04325 0.301603L9.56777 5.05638C10.1441 5.55238 10.1441 6.44762 9.56777 6.94362L4.04325 11.6984C3.24036 12.3894 2 11.8166 2 10.7548Z"
    fill="currentColor"
  />
</template>
